import type { ButtonConfig } from '../../declare'
import { useContext } from 'react'
import { Popconfirm } from 'antd'
import { EasyIcon, EditTreeContext, postMsg } from 'src/components'
import { $api } from 'src/plugins'

type Props = {
  config: ButtonConfig
}
const DeleteConfirmBtn = (props: Props) => {
  const tree = useContext(EditTreeContext)

  const handleDelete = () => {
    const { Nav_PageTree = {} } = tree.treeConfig
    const { BATCH_DEL_API_URL } = Nav_PageTree
    if (!BATCH_DEL_API_URL) {
      postMsg('未配置删除API', 'error')
      return
    }
    const currTree = tree.flatTreeData.filter((item: any) => tree.selectedKeys.indexOf(item.ID) !== -1)
    const parentTree = tree.flatTreeData.find((item: any) => item.ID === currTree[0].PARENT_ID)
    $api['app/getDataByGet'](
      { ids: tree.selectedKeys.join(',') },
      { url: BATCH_DEL_API_URL }
    ).then((res: any) => {
      if (res) {
        postMsg('删除成功')
        tree.getTreeData(parentTree)
      }
    })
  }

  const { LABEL, ICON } = props.config
  return (
    <Popconfirm
      title='确认删除？'
      onConfirm={handleDelete}
      getPopupContainer={() => document.getElementsByClassName(tree.uniqClass)[0] as HTMLElement}
    >
      <EasyIcon title={LABEL} type={ICON} defaultIcon='DeleteOutlined' className='color-error' />
    </Popconfirm>
  )
}

export default DeleteConfirmBtn